<template>
    <div>
        <div class="box">
            <el-dialog v-model="dialogVisible" :title="title" width="30%" :before-close="handleCloseAdd">
                <!-- <span>这是一段信息</span> -->
                <el-form ref="form" :model="form" :rules="rules">
                    <el-form-item label="所属用户" prop="username" label-width="100px">
                        <el-select ref="selectAdd" v-model="form.username" placeholder="请选择用户"
                            @visible-change='visibleChange'>
                            <el-option :label="item.name" :value="item.orgCode" v-for="item in regionList"
                                :key="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="账号:" prop="memberUserName" label-width="100px">
                        <el-input v-model="form.memberUserName" autocomplete="off" :disabled="this.title != '修改注册会员'?false:true"></el-input>
                    </el-form-item>
                    <el-form-item v-if="title === '新增注册会员'" label="设置密码:" prop="password" label-width="100px">
                        <el-input v-model="form.password" type="password" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item v-else label="设置密码:" label-width="100px">
                        <el-input v-model="form.password" type="password" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item v-if="title === '新增注册会员'" label="确认密码:" prop="checkPassword" label-width="100px">
                        <el-input v-model="form.checkPassword" type="password" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item v-else label="确认密码:" label-width="100px">
                        <el-input v-model="form.checkPassword" type="password" autocomplete="off"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="账号关键字:" label-width="100px">
                <el-input v-model="form.code" autocomplete="off"></el-input>
            </el-form-item> -->
                    <el-form-item label="性别:" prop="sex" label-width="100px">
                        <!-- <el-input v-model="form.name" autocomplete="off"></el-input> -->
                        <el-radio-group v-model="form.sex">
                            <el-radio label="男"></el-radio>
                            <el-radio label="女"></el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="手机:" prop="mobile" label-width="100px">
                        <el-input v-model="form.mobile" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="昵称:" label-width="100px">
                        <el-input v-model="form.name" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <template #footer>
                    <span class="dialog-footer">
                        <el-button type="primary" @click="submitForm('form')">
                            提交
                        </el-button>
                        <el-button @click="handleCloseAdd">返回</el-button>
                    </span>
                </template>
            </el-dialog>
        </div>
        <userAreaDelete v-if="userAreaDeleteShow" @handleClose='handleClose'
            @singleSelectionClick="singleSelectionClick">
        </userAreaDelete>

    </div>
</template>
<script>
import { userTree } from '@/assets/api/api'
import { memberUpdate, memberAddInfo } from '@/assets/api/logapi'
import userAreaDelete from '@/components/userArea/index.vue';

export default {
    props: ['detailsObj'],
    components: {
        userAreaDelete,
    },
    data() {
        //   var validatepassword = (rule, value, callback) => {
        //   if (value === '') {
        //     callback(new Error('请输入密码'));
        //   } else {
        //     if (this.form.password !== '') {
        //       this.$refs.form.validateField('password');
        //       console.log();
        //     }
        //     callback();
        //   }
        // };
        //   var validatecheckPassword = (rule, value, callback) => {
        //   if (value === '') {
        //     callback(new Error('请再次输入密码'));
        //   } else if (value !== this.form.password) {
        //     callback(new Error('两次输入密码不一致!'));
        //   } else {
        //     callback();
        //   }
        // };
        return {
            regionList: [],
            dialogVisible: true,
            form: {
                username: "",
                memberId: "",
                orgCode: "",
                password: "",
                checkPassword: "",
                code: "",
                sex: "男",
                //   email:"",
                mobile: "",
                name: "",
                memberUserName: ""
            },
            title: '',
            treeData: [],
            rules: {
                username: [
                    { required: true, message: '请输入所属用户', trigger: 'blur' },
                    // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
                memberUserName: [
                    { required: true, message: '请输入账号', trigger: 'change' }
                ],
                //   password: [
                //       { validator: validatepassword, trigger: 'blur' }
                //       ],
                //   checkPassword: [
                //       { validator: validatecheckPassword, trigger: 'blur' }
                //       ],
                code: [
                    { required: true, message: '请输入账号', trigger: 'change' }
                ],
                sex: [
                    { required: true, message: '', trigger: 'change' }
                ],
                //   email: [
                //       { required: true, message: '请输入邮箱', trigger: 'change' }
                //       ],
                mobile: [
                    { required: true, message: '请输入手机号', trigger: 'change' }
                ],
            },
            userAreaDeleteShow: false
        };
    },
    created() {
        this.menuGetUserTreeGet()
    },
    mounted() {

        console.log(this.detailsObj,'11123333');
        if (JSON.stringify(this.detailsObj) !== '{}') {
            // console.log(this.detailsObj,'修改注册会员');
            this.title = '修改注册会员',
                //    this.form.email = this.detailsObj.email || '',
                this.form.username = this.detailsObj.orgCode || '',
                this.form.code = this.detailsObj.code || '',
                this.form.sex = this.detailsObj.sex == 1 ? '男' : '女' || '',
                this.form.mobile = this.detailsObj.mobile || '',
                this.form.name = this.detailsObj.name || ''
            this.form.memberUserName = this.detailsObj.memberUserName || ''
            this.form.password = this.detailsObj.password
            this.form.checkPassword = this.detailsObj.checkPassword
        }
        else {
            this.title = '新增注册会员'
            console.log(this.detailsObj, '新增注册会员');

        }
    },
    methods: {
        visibleChange() {
            this.userAreaDeleteShow = true
            this.$refs.selectAdd.blur()
        },
        singleSelectionClick(item) {
            this.regionList = [item]
            this.form.username = item.orgCode
            this.userAreaDeleteShow = false
            console.log(item, item.name, '单选');
        },
        handleClose() {
            this.userAreaDeleteShow = false
        },
        menuGetUserTreeGet() {
            const params = {
                userId: JSON.parse(localStorage.getItem('user')).id
            };
            userTree(params).then((res) => {
                console.log(res, 123456);
                // this.userTrData = res.data.data
                this.regionList = res.data.data
                this.regionList.forEach((item,index) => {
                    item.name = item.alias ||item.siteName ||item.circleName ||item.username ||item.label
                })
                this.form.username = res.data.data[0].orgCode
            }).catch((err) => {
                console.log(err);
            })
        },
        handleCloseAdd() {
            this.$emit('AddShowClick')
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.title == '修改注册会员') {
                        this.memberUpdatesubmit()
                        console.log('修改', 8888);
                    } else if (this.title == '新增注册会员') {
                        this.memberAddInfosubmit()
                        console.log(8888);
                    }
                } else {
                    return false;
                }
            });
        },
        // 修改
        memberUpdatesubmit() {
            const params = {
                checkPassword: this.form.checkPassword,
                code: this.form.code,
                email: this.form.email,
                memberId: this.detailsObj.memberId,
                memberUserName: this.form.memberUserName,
                mobile: this.form.mobile,
                name: this.form.name,
                orgCode: this.form.username,
                password: this.form.password,
                sex: this.form.sex == '男' ? '1' : '0',
                loginUserId: JSON.parse(localStorage.getItem('user')).id,

            }
            memberUpdate(params).then((res) => {
                console.log(res, '提交成功');
                this.$message({
                    message: '提交成功',
                    type: 'success',
                });
                this.handleCloseAdd()
            }).catch((err) => {
                console.log(err, '提交失败');
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
            })

        },
        // 添加
        memberAddInfosubmit() {
            const params = {
                checkPassword: this.form.checkPassword,
                code: this.form.code,
                email: this.form.email,
                memberId: this.form.memberId,
                memberUserName: this.form.memberUserName,
                mobile: this.form.mobile,
                name: this.form.name,
                orgCode: this.form.username,
                // orgCode: this.regionList[0].orgCode,
                password: this.form.password,
                sex: this.form.sex == '男' ? '1' : '0',
                loginUserId: JSON.parse(localStorage.getItem('user')).id,
                schoolId:null,

            }
            memberAddInfo(params).then((res) => {
                console.log(res, '提交成功');
                this.handleCloseAdd()
            }).catch((err) => {
                //   console.log(err,'新增失败');
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
            })
        },
        arrayTreeAddLevel(array, levelName = 'level', childrenName = 'children') {
            if (!Array.isArray(array)) return []
            const recursive = (array, level = 0) => {
                level++
                return array.map(v => {
                    v[levelName] = ''
                    // for( let value     )
                    for (var i = 0; i < level; i++) {
                        v[levelName] = v[levelName] + ' ——'
                    }
                    // level.forEach(item=> {
                    // })
                    const child = v[childrenName]
                    if (child && child.length) recursive(child, level)
                    return this.treeData.push(v)
                })
            }
            return recursive(array)
        },

    }
};
</script>
<style scoped lang="scss">
.box {
    :deep() {
        .el-dialog__body {
            height: 350px;
            text-align: center;

            // // justify-content: space-evenly;align-items: center;
            // align-items: center;

        }

        .el-select--small .el-select__wrapper {
            width: 220px;
            height: 30px;
        }

        .el-dialog__footer {
            text-align: center;
        }

        .el-select .el-input {
            width: 128% !important;
        }

        .el-input--small {
            width: 50%;
            border-radius: 0px;
            height: 30px;
        }

        .el-form-item--small {
            height: 25px;
        }

        .el-form-item--small .el-form-item__label {
            line-height: 30px;
        }

        .el-radio.el-radio--small {
            height: 32px;
        }
    }
}
</style>